var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"svgColor":'#fff',"back":true}}),_c('div',{staticClass:"content"},[_c('div',{attrs:{"id":"container"}}),_c('div',{staticClass:"map-refresh",on:{"click":_vm.getriding}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }